import useSWR from "swr";
import authService from "../services/auth-service";

export default function useOptimisticFetchUsers() {
  return useSWR({}, authService.userEndpoint.userList);
}